import { useMemo } from 'react';

import { EditorView } from '@lyearn/lygo-core';

import { PopperProps } from '../../types';
import { getCurrentSelectionNode, getElementPos } from '../../utils';
import { getBlockMenuPlacement } from './utils/utils';

export const usePopperOptions = (anchorEl: PopperProps['anchorEl'], textNodeCount: number) => {
  return useMemo(() => {
    const placement = getBlockMenuPlacement(anchorEl, textNodeCount);
    return {
      popperOptions: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: placement.offset,
            },
          },
          {
            name: 'flip',
            enabled: false,
          },
        ],
      },
      placement: placement.placement,
    };
  }, [anchorEl, textNodeCount]);
};

export const useCurrentlySelectedNode = (
  open: boolean,
  anchorEl: PopperProps['anchorEl'],
  view: EditorView,
) => {
  return useMemo(() => {
    if (open && anchorEl && view) {
      const elementPos = getElementPos(anchorEl, view);
      if (elementPos?.pos) {
        return getCurrentSelectionNode(view, elementPos.pos);
      }
    }
    return null;
  }, [anchorEl, open, view]);
};
